//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { minLength, sameAs, required } from "vuelidate/lib/validators";
import { mapActions } from "vuex";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";

import { PassValidator } from "../Login/PassValidator";

export default {
    components: {
        AQModal,
        AQInput
    },
    props: {
        value: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            open: true,
            saved: false,
            primary: {
                label: this.$t("generic.done"),
                disabled: false
            },
            passObj: {
                newPass: "",
                oldPass: "",
                confirmPass: ""
            },
            percent: null,
            color: null,
            samePassword: false,
            oldPassError: false
        };
    },
    computed: {
        validateNewPass() {
            let msg = "";
            if (!this.passObj.newPass || !this.$v.passObj.newPass.minLength || !this.$v.passObj.newPass.PassValidator) {
                msg = this.$t("admin.usersAndRoles.manualAddModal.passwordRequirements");
            } else if (this.samePassword) {
                msg = this.$t("userProfile.samePassword");
            }
            return msg;
        },
        validateOldPass() {
            let msg = "";
            if (!this.passObj.oldPass) {
                msg = this.$t("userProfile.enterOldPass");
            } else if (this.oldPassError) {
                msg = this.$t("userProfile.oldPassNoMatch");
            }
            return msg;
        },
        validateConfirmPass() {
            let msg = "";
            if (!this.passObj.confirmPass) {
                msg = this.$t("userProfile.confirmPass");
            } else if (!this.$v.passObj.confirmPass.sameAs) {
                msg = this.$t("userProfile.sameAsErr");
            }
            return msg;
        }
    },
    watch: {
        value: {
            immediate: true,
            handler(v) {
                if (v) {
                    this.passObj = Object.assign(this.passObj, v);
                }
            }
        }
    },
    validations: {
        passObj: {
            oldPass: {
                required
            },
            newPass: {
                minLength: minLength(6),
                required,
                PassValidator
            },
            confirmPass: {
                sameAsPassword: sameAs("newPass"),
                required
            }
        }
    },
    created() {
    },

    methods: {
        ...mapActions("userProfile", ["checkOldPassword"]),
        actionsDlg($event) {
            if ($event === "primary") {
                if (!this.$v.passObj.$invalid) {
                    this.passObj.modifyDate = new Date();
                    this.$emit("input", this.passObj);
                } else {
                    this.$v.passObj.$touch();
                    return false;
                }
                this.checkOldPassword({ oldPassword: this.passObj.oldPass, newPassword: this.passObj.newPass }).then(
                    () => {
                        this.saved = true;
                        this.open = false;
                        this.$emit("saved");
                    },
                    (err) => {
                        if (err.response.data.error === "Password already in use for this account. Please choose another password.") {
                            this.samePassword = true;
                        } else if (err.response.data.error === "Passwords don't match") {
                            this.oldPassError = true;
                        }
                        this.saved = false;
                        this.open = true;
                    }
                );
            } else {
                this.$emit("cancelChanges");
                this.open = false;
            }
            return false;
        },
        afterHide() {
            this.$emit("modalClosed");
        }
    }
};
